import React, { Component } from "react";
import "./AddonUI.css"; // Importing CSS file

class AddonUI extends Component {
    constructor(props) {
        super(props);
        this.radioRef = React.createRef();
    }

    handleRadioClick = (e) => {
        // Prevent event bubbling to avoid conflicts
        e.stopPropagation();
        
        
        // Allow click for both required and optional addons
        this.props.onCheck();
    }

    handleRadioChange = (e) => {
        // Handle radio input change
        e.stopPropagation();

        
        // Allow change for both required and optional addons
        this.props.onCheck();
    }

    handleContainerClick = (e) => {
        // Only handle click if it's a radio type and click is not on the radio input or label
        if (this.props.uiType === "radio" && 
            e.target.type !== "radio" && 
            !e.target.closest('.radio-wrapper')) {
            e.stopPropagation();
    
            this.props.onCheck();
        }
    }

    render() {
        let functionality = null;
        switch (this.props.uiType) {
            case "checkbox":
                functionality = (
                    <input
                        type="checkbox"
                        onChange={this.props.onCheck}
                        checked={this.props.isChecked !== undefined ? this.props.isChecked : this.props.quantity > 0}
                    />
                );
                break;
            case "radio":
                // Create a safe ID using addon ID and name (which now includes addonListIndex)
                const radioId = `radio-${this.props.name}-${this.props.addonId || 'default'}`;
                const isUnchecked = this.props.quantity === 0;
                const isRequired = this.props.min > 0;
                
        
                //     id: radioId,
                //     name: this.props.name,
                //     quantity: this.props.quantity,
                //     min: this.props.min,
                //     isRequired: isRequired,
                //     isUnchecked: isUnchecked
                // });
                
                functionality = (
                    <div 
                        className={`radio-wrapper ${isUnchecked ? 'unchecked' : ''} ${isRequired ? 'required' : 'optional'}`} 
                    >
                        <input
                            ref={this.radioRef}
                            id={radioId}
                            type="radio"
                            name={this.props.name || "addon-radio"}
                            onChange={this.handleRadioChange}
                            checked={this.props.quantity > 0}
                            style={{ 
                                cursor: 'pointer',
                                opacity: isRequired ? 1 : 0.8,
                                pointerEvents: 'auto',
                                position: 'relative',
                                zIndex: 10
                            }}
                        />
                    </div>
                );
                break;
            default:
                functionality = (
                    <div className="cart-item-controls">
                        <button className="btn minus" disabled={this.props.disabled || this.props.quantity == 0} onClick={() => {
                            let qty = this.props.quantity;
                            this.props.onChange(--qty);
                        }}>-</button>
                        <span className="cart-item-quantity">{this.props.quantity}</span>
                        <button className="btn plus" disabled={this.props.disabled || this.props.quantity == this.props.max} onClick={() => {
                            let qty = this.props.quantity;
                            this.props.onChange(++qty);
                        }}>+</button>
                    </div>
                );
                break;
        }

        return (
            <div 
                className={`AddonUI cart-item ${this.props.uiType === "radio" ? "radio-clickable" : ""}`}
                onClick={this.handleContainerClick}
            >
                {this.props.enableImage ? (
                    <div className="cart-item-image">
                    <img
                        src={this.props.thumb} // Replace with actual image URL
                        alt={this.props.title}
                    />
                </div>
                ): null}
                <div className="cart-item-details">
                    <div className="cart-item-name">{this.props.title}</div>
                    {typeof this.props.price === 'string' ? (
                        <div className="cart-item-price">{this.props.price}</div>
                    ) : (
                        <div className="cart-item-price">{this.props.price}</div>
                    )}
                </div>
                {functionality}
            </div>
        );
    }
}

export default AddonUI;
